import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { RootReducerState } from '../app-state-types';

export const useAppSelector: TypedUseSelectorHook<RootReducerState> = useSelector;
